import { gql } from "apollo-angular";

import { ASSET_FRAGMENT } from "../../../common/graphql/fragments.graphql";

export { ADD_TO_CART } from "../../../common/graphql/fragments.graphql";

export const GET_PRODUCT_DETAIL = gql`
    query GetProductDetail($slug: String!) {
        product(slug: $slug) {
            id
            name
            description
            enabled
            customFields {
                gtin
                brand
                quantityPerBox
            }
            variants {
                id
                name
                options {
                    code
                    name
                }
                stockLevels {
                    stockOnHand
                    stockAllocated
                }
                price
                priceWithTax
                sku
                moq
                preOrderShippingDate
                pricing {
                    id
                    validFrom
                    validTo
                    taxRate
                    goodsStatus
                    currency
                    mov
                    shippingDate
                    supplyType
                    volumeDiscounts
                    prePaymentPercentage
                    isLimitedTimeOffer
                    isDecoded
                    isDamagedPackaging
                    isShortBbd
                    fullPackageOnly
                }
                pricingProduct {
                    minQ
                    maxQ
                    brand
                }
            }
            featuredAsset {
                ...Asset
            }
            assets {
                ...Asset
            }
            collections {
                id
                slug
                breadcrumbs {
                    id
                    name
                    slug
                }
            }
        }
    }
    ${ASSET_FRAGMENT}
`;

export const GET_CURRENT_CUSTOMER = gql`
    query GetCurrentCustomer {
        activeCustomer {
            id
        }
    }
`;

export const GET_PRODUCT_RETAIL_PRICE_INFO = gql`
    query GetProductRetailPriceInfo($productId: ID!) {
        productRetailPriceInfo(productId: $productId) {
            ean
            updatedAt
            prices {
                domainId
                marketplace
                countryName
                currency
                asin
                retailAvg30
                status
                keepaLastUpdate
                retrievedAt
            }
        }
    }
`;

export const GET_PDP_SETTINGS = gql`
    query GetPdpSettings { storefrontSettings { startSellingUrl } }
`;
